"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListWrapper = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const ListWrapper = exports.ListWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1mnd1pc0"
} : {
  target: "e1mnd1pc0",
  label: "ListWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "1xrjta7",
  styles: "display:grid;grid-template-columns:1fr;grid-row-gap:1em"
} : {
  name: "1xrjta7",
  styles: "display:grid;grid-template-columns:1fr;grid-row-gap:1em",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});